import { Spin } from 'antd';
import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { LoadingOutlined } from '@ant-design/icons';
import "react-pdf/dist/esm/Page/TextLayer.css";



// Configuração global para o react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;


type pdfType = {
    pdfUrl: string;
}

const options = {
    cMapUrl: '/cmaps/',
    standardFontDataUrl: '/standard_fonts/',
};

export default function PdfReader({ pdfUrl }: pdfType) {
    const [numPages, setNumPages] = useState<number>();
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [isLoading, setIsLoading] = useState(true);


    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setNumPages(numPages);
        setIsLoading(false);
    }

    return (
        <div style={{ display: "flex", justifyContent: "center" }}>

            <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess} options={options}>
                {isLoading ? (
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                ) : (
                    <Page pageNumber={pageNumber} width={900} renderTextLayer={false} renderAnnotationLayer={false} />
                )}
            </Document>
            {!isLoading && (
                <div>
                    <p>
                        Page {pageNumber} of {numPages}
                    </p>
                    <button
                        onClick={() => setPageNumber(Math.max(pageNumber - 1, 1))}
                        disabled={pageNumber <= 1}
                    >
                        Previous
                    </button>
                    <button
                        onClick={() => setPageNumber(Math.min(pageNumber + 1, numPages as number))}
                        disabled={pageNumber >= numPages!}
                    >
                        Next
                    </button>
                </div>
            )}

        </div>
    );
}
